<template>
  <main-template>
    <div class="form form-additional" v-if=props.visible>
      <div class="title">登録情報確認</div>
      <div class="value element js-animation">
        <div class="item_key">証券番号</div>
        <div class="space"></div>
        <div class="item_value">{{ data.policyNumber }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">ご連絡者様のお名前</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c1FullName}}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">ご連絡者様のお電話番号</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c1Tel}}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">ご契約者様との関係</div>
        <div class="space"></div>
        <div class="item_value">{{ $t(data?.c1InsuRlRelation?.description || '') }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">ご契約者様のお名前(カナ)</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c1ContractNameKana }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">ご契約者様のお名前</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c1ContractFullName }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">ご契約者様のお電話番号</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c1HomeTel }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">契約車両の登録番号</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c1RegistraNum }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">事故発生年月日</div>
        <div class="space"></div>
        <div class="item_value">{{ formatDate(data.c2AccidentDate) }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">事故発生時刻</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c2AccidentTime }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">事故場所</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c2JikoPlace }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">運転されていた方のお名前(カナ)</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c2DriverNameKara }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">運転されていた方のお名前</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c2DriverFullName }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">性別</div>
        <div class="space"></div>
        <div class="item_value">{{ $t(data?.c2Sex?.description || '') }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">生年月日</div>
        <div class="space"></div>
        <div class="item_value">{{ formatDate(data.c2DriverDob) }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">年齢</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c2DriverAge }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">TEL</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c2DriverTel }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">ご契約者様との関係</div>
        <div class="space"></div>
        <div class="item_value">{{ $t(data?.c2InsuRlRelation?.description || '') }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">登録番号</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c2RegistraNum }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">事故状況</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c2AccidentConditionText }}</div>
      </div>
      <div class="value element js-animation">
        <div class="item_key">その他連絡事項</div>
        <div class="space"></div>
        <div class="item_value">{{ data.c2SpecialItem }}</div>
      </div>
      <div class="btn_box" >
        <button type="button" @click="handleBack" class="btn btn-outline-secondary btn-back" data-href="/Web/Contract/Back">戻る</button>
        <input type="submit" @click="handleSubmission" value="送信" class="btn btn-success">
      </div>
    </div>
  </main-template>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import MainTemplate from '@/components/MainTemplate.vue'
import { useStore } from 'vuex'
import router from '@/router'
import { DECREASE_LOADING_COUNT_STATE, INCREASE_LOADING_COUNT_STATE } from '@/constant/store/MutationTypes'

const props = defineProps({ visible: Boolean })
const route = useRoute()
const store = useStore()

const data = ref('')

const formatDate = (date: any) => {
  if (date == null || date === '') {
    return ''
  }

  // check for invalid date
  if (isNaN(date.getTime())) {
    return ''
  }
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
  const month = date.getMonth() < 9 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  return date.getFullYear() + '/' + month + '/' + day
}

const sendToSever = (data: any) => {
  store.commit(`fnol/${INCREASE_LOADING_COUNT_STATE}`)
  store.dispatch('fnol/submit', data)
    .then(response => {
      const responseData = response.data.data
      if (responseData.receivedNumber) {
        router.push('/receipt/' + responseData.receivedNumber)
      } else {
        router.push({ path: '/data-submission-error', query: { data: JSON.stringify(data) } })
      }
      store.commit(`fnol/${DECREASE_LOADING_COUNT_STATE}`)
    }).catch((error: any) => handleError(error, data))
}

const handleError = (error: any, data: any) => {
  store.commit(`fnol/${DECREASE_LOADING_COUNT_STATE}`)
  const dataStr = JSON.stringify(data)

  const errorMsg = error.response?.data.errorMessage

  if (errorMsg) {
    router.push({ path: '/network-submission-error', query: { data: dataStr } })
  }
}

const handleSubmission = () => {
  sendToSever(data.value)
}

const updateData = (updateData: any) => {
  data.value = updateData
}

const handleBack = () => {
  const jsonData = JSON.stringify(data.value)
  router.push({ path: '/fnol-form', query: { data: jsonData } })
}

onMounted(() => {
  if (!route.query.data) {
    return
  }
  const rawData = JSON.parse(route.query.data || '{}')
  rawData.c2AccidentDate = new Date(rawData.c2AccidentDate)
  rawData.c2DriverDob = rawData.c2DriverDob !== null ? new Date(rawData.c2DriverDob) : null
  updateData(rawData)
})

const emit = defineEmits(['submit', 'back'])
</script>

<style scoped>
.form-additional {
  top: 73px;
  margin: 5px;
  text-align: left;
}

.value {
  margin: 10px;
  font-size: 1rem;
  border-bottom: solid 1px darkred;
  display: flex;
}

.item_key {
  background: white;
  padding: 10px;
  width: 50%;
  color: darkred;
  border-radius: 5px;
  font-weight: bold;
}

.item_value {
  margin: auto;
  font-weight: bold;
  font-size: 1rem;
  width: 50%;
  text-align:center;
}

.space {
  margin: 0 10%;
}

input {
  margin-bottom: 10px;
}

.form {
  top:80px;
  margin: 5px;
  margin-bottom: 30px;
}

.btn_box {
  width: 100%;
  display: flex;
}

.btn_box button {
  width: 50%;
  margin: 10px;
}

.btn_box input {
  margin: 10px;
}

.btn-success {
  width: 50%;
}

.value {
  margin: 10px;
  font-size: 18px;
  padding: unset;
  border-bottom: solid 1px darkred;
  display: flex;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin: 20px 0;
  color: white;
  padding: 10px;
  background-color: darkred;
  border-radius: 5px;
}
</style>
